import { AddChildNodeInput } from "../types/AddChildNodeInput";

export function convertAnnotationToNode(annotation: any, mapId: string, parentId: String) {
    const node: AddChildNodeInput = {
        mapID: mapId,
        parentID: parentId,
        node: { accessPolicy: "4hlNGcf2RRCRuYv_1xZlhg", type: "claim" },
        link: { group: "freeform", orderKey: "a1", form: "question" },
        revision: {
            phrasing: {
                text_question: annotation.text,
                text_base: "",
                terms: [],
                text_negation: "",
            },
            attachments: [
                {
                    references: {
                        sourceChains: [
                            {
                                sources: [
                                    {
                                        "link": annotation.target[0].source,
                                        "type": "webpage"
                                    },
                                    {
                                        type: "hypothesisAnnotation",
                                        hypothesisAnnotationId: annotation.id
                                    }
                                ]
                            },
                        ]
                    },
                },
                {
                    quote: {
                        content: `(${annotation.target[0].selector[2].exact})`,
                        sourceChains: [
                            {
                                sources: [
                                    {
                                        "link": annotation.target[0].source,
                                        "type": "webpage"
                                    },
                                    {
                                        type: "hypothesisAnnotation",
                                        hypothesisAnnotationId: annotation.id
                                    }
                                ]
                            }
                        ]
                    } as unknown as JSON,
                },
            ]

        },
    }

    return node;
}
